export const de = {
  // Header
  header: {
    home: 'Home',
    nonSurgicalAesthetics: 'Nicht-chirurgische Ästhetik',
    surgicalProcedures: 'Chirurgische Eingriffe',
    about: 'Über uns',
    blog: 'Blog',
    contact: 'Kontakt',
    expertDoctor: 'Expertenarzt',
    aestheticsInTurkey: 'Ästhetik in der Türkei',
    paymentMethods: 'Zahlungsmethoden',
    kvkk: 'DSGVO',
    rhinoplasty: 'Nasenkorrektur',
    liposuction: 'Fettabsaugung',
    bbl: 'Brazilian Butt Lift',
    tummyTuck: 'Bauchstraffung',
    breastAugmentation: 'Brustvergrößerung',
    breastLift: 'Bruststraffung',
    breastReduction: 'Brustverkleinerung',
    gynecomastia: 'Gynäkomastie',
    armLift: 'Oberarmstraffung',
    thighLift: 'Oberschenkelstraffung',
    genitalAesthetics: 'Genitalästhetik',
    postBariatricSurgery: 'Post-bariatrische Chirurgie',
    medicalAesthetics: 'Medizinische Ästhetik',
    wrinkleTreatment: 'Faltenbehandlung',
    skinFiller: 'Hautfüller',
    skinCare: 'Hautpflege',
    medicalSkinCare: 'Medizinische Hautpflege',
    aquapeelSkinCare: 'Aquapeel Hautpflege',
    dermapenApplication: 'Dermapen-Anwendung',
    pumpkinPeel: 'Kürbis-Peeling',
    regionalSlimming: 'Regionale Fettreduktion',
    g5Massage: 'G5-Massage',
    threadLifting: 'Fadenlifting',
    mesotherapy: 'Mesotherapie',
    facialAesthetics: 'Gesichtsästhetik',
    eyebrowLift: 'Brauenlifting',
    earCorrection: 'Ohrenkorrektur',
    dimpleAesthetics: 'Grübchenästhetik',
    facialFatInjection: 'Gesichtsfettinjektion',
    faceLift: 'Gesichtsstraffung',
    foreheadLift: 'Stirnlifting',
    neckLift: 'Halsstraffung',
    buccalFatRemoval: 'Wangenfettentfernung',
    moleRemoval: 'Muttermalentfernung',
    chinLiposuction: 'Kinnfettabsaugung',
    bodyAesthetics: 'Körperästhetik',
    breastAesthetics: 'Brustästhetik'
  },
  // Footer
  footer: {
    contact: 'Kontakt',
    address: 'Adresse',
    phone: 'Telefon',
    email: 'E-Mail',
    workingHours: 'Öffnungszeiten',
    weekdays: 'Montag - Freitag',
    saturday: 'Samstag',
    allRightsReserved: 'Alle Rechte vorbehalten',
    socialMedia: 'Soziale Medien',
    aestheticsInTurkey: 'Ästhetik in der Türkei',
    paymentMethods: 'Zahlungsmethoden',
  },
  // Homepage
  homepage: {
    hero: {
      title: 'Ästhetik und Schönheit',
      subtitle: 'Professionelle Lösungen für Ihre Schönheit',
      description: 'Wir bieten Ihnen den besten Service für Ihre ästhetischen Bedürfnisse mit unserem Expertenteam und modernen Techniken.',
      button: 'Termin vereinbaren',
      slides: {
        rhinoplasty: {
          title: 'Nasenkorrektur',
          description: 'Eine natürliche Nase, die zu Ihrem Gesicht passt, ist kein Traum! Atmen Sie besser und gewinnen Sie Selbstvertrauen mit einer Nasenkorrektur. Es ist Zeit für eine elegante Note Ihrer Schönheit! Spüren Sie den Unterschied mit modernen Techniken und fachkundiger Hand. Lächeln Sie zufrieden jedes Mal, wenn Sie in den Spiegel schauen.',
          infoButton: 'Nasenkorrektur Informationsseite'
        },
        liposuction: {
          title: 'Liposuktion',
          description: 'Ihr Traumkörper ist jetzt möglich! Verabschieden Sie sich von überschüssigem Fett mit modernen Liposuktion-Methoden. Es ist Zeit, Ihre Form neu zu gestalten! Regionale Überschüsse werden Geschichte, Sie werden neu geboren.',
          infoButton: 'Liposuktion Informationsseite'
        },
        bbl: {
          title: 'Brazilian Butt Lift (BBL)',
          description: 'Vollere, formvollere und natürlichere Gesäßformen! Fügen Sie Ihrem Körper Kurven mit Brazilian Butt Lift hinzu. Sie werden von Ihrem neuen Look begeistert sein! Erzielen Sie natürliche und dauerhafte Ergebnisse mit Ihrem eigenen Fett.',
          infoButton: 'BBL Informationsseite'
        }
      }
    },
    services: {
      title: 'Unsere Dienstleistungen',
      subtitle: 'Wir bieten Ihnen den besten Service mit modernen Techniken und unserem Expertenteam',
      cards: {
        rhinoplasty: {
          title: 'Nasenkorrektur',
          description: 'Lernen Sie unsere Expertenärzte für eine natürliche Nase kennen, die zu Ihrem Gesicht passt.',
          button: 'Mehr erfahren',
        },
        faceLift: {
          title: 'Gesichtsästhetik',
          description: 'Gesichtsästhetische Operationen für ein junges und dynamisches Aussehen.',
          button: 'Mehr erfahren',
        },
        bodyAesthetics: {
          title: 'Körperästhetik',
          description: 'Professionelle Lösungen, um Ihren Traumkörper zu erreichen.',
          button: 'Mehr erfahren',
        },
      },
    },
    testimonials: {
      title: 'Patientenbewertungen',
      subtitle: 'Die Erfahrungen und die Zufriedenheit unserer Patienten sind unser wertvollstes Feedback',
      viewAll: 'Alle Bewertungen anzeigen',
      items: {
        rhinoplasty: {
          name: 'Sophie K.',
          location: 'Berlin',
          comment: 'Ich bin sehr zufrieden mit meiner Nasenkorrektur. Dank Dr. Barış Çins professioneller Herangehensweise und Expertise habe ich die Nase bekommen, von der ich geträumt habe. Ich habe mich während des gesamten Prozesses sicher gefühlt.',
          rating: 5
        },
        liposuction: {
          name: 'Thomas S.',
          location: 'München',
          comment: 'Die Veränderung meines Körpers nach der Liposuktion ist unglaublich. Vielen Dank an Dr. Barış Çin und sein Team. Ich bin jetzt selbstbewusster.',
          rating: 5
        },
        bbl: {
          name: 'Laura A.',
          location: 'Hamburg',
          comment: 'Ich bin sehr glücklich nach meiner BBL-Operation. Dank Dr. Barış Çins Erfahrung und sorgfältiger Arbeit habe ich erstaunliche Ergebnisse erzielt. Ich empfehle es definitiv weiter.',
          rating: 5
        }
      }
    },
    satisfactionVideos: {
      title: 'Patientenzufriedenheitsvideos',
      subtitle: 'Sehen Sie sich die Erfahrungen und die Zufriedenheit unserer Patienten im Videoformat an',
      viewAll: 'Alle Videos anzeigen',
      items: {
        rhinoplasty: {
          title: 'Nasenkorrektur-Erfahrung',
          description: 'Patientenerfahrung und Zufriedenheit nach der Nasenkorrektur',
          duration: '3:45'
        },
        liposuction: {
          title: 'Liposuktion-Erfahrung',
          description: 'Patientenerfahrung und Zufriedenheit nach der Liposuktion',
          duration: '4:20'
        },
        bbl: {
          title: 'BBL-Erfahrung',
          description: 'Patientenerfahrung und Zufriedenheit nach der Brazilian Butt Lift Operation',
          duration: '3:55'
        }
      }
    },
    about: {
      title: 'Über uns',
      readMore: 'Weiterlesen',
    },
    contact: {
      title: 'Kontakt',
      subtitle: 'Kontaktieren Sie uns für Ihre ästhetischen Bedürfnisse',
      name: 'Ihr Name',
      phone: 'Ihre Telefonnummer',
      message: 'Ihre Nachricht',
      send: 'Nachricht senden',
      address: 'Adresse',
      addressValue: 'Kosuyolu Bezirk Mehmet Akfan Straße Nr.19-21 Kadikoy Istanbul Türkei',
      email: 'E-Mail',
      emailValue: 'drbariscin86@gmail.com',
      phoneValue: '+90 555 123 4567',
      workingHours: 'Öffnungszeiten',
      workingHoursValue: 'Montag - Freitag: 09:00 - 18:00',
      socialMedia: 'Soziale Medien',
      socialMediaDescription: 'Folgen Sie uns in den sozialen Medien für die neuesten Updates und Informationen',
      location: 'Standort',
      locationDescription: 'Unsere Klinik befindet sich im Herzen von Kadikoy und ist gut mit öffentlichen Verkehrsmitteln erreichbar',
      appointment: 'Termin',
      appointmentDescription: 'Kontaktieren Sie uns umgehend, um einen Termin zu Ihrer Wunschzeit zu vereinbaren und detaillierte Informationen zu erhalten'
    },
    credentials: {
      title: 'Unsere Zertifikate',
      subtitle: 'Vom türkischen Gesundheitsministerium ausgestellte Zulassung und internationale Gesundheitstourismus-Zertifikate',
      healthTurkiyeTitle: 'Health Türkiye',
      healthTurkiyeDescription: 'Zulassung für Gesundheitstourismus – Gesundheitsministerium der Republik Türkei',
      certificateTitle: 'Zulassungsurkunde',
      certificateDescription: 'Sehen Sie unsere offizielle Zulassungsurkunde als PDF an',
      viewDocument: 'Dokument ansehen',
      viewImage: 'Vergrößern'
    },
    doctorIntro: {
      title: "FACHARZT",
      name: "Op. Dr. Barış Çin",
      description: "Op. Dr. Barış Çin ist ein plastischer Chirurg, der in seiner Privatklinik in Kadıköy und in verschiedenen erstklassigen Krankenhäusern wie Academic und Acıbadem Krankenhäusern tätig ist. Zusammen mit einem Team, das nach Exzellenz strebt, stehen wir Ihnen rund um die Uhr zur Verfügung, um Ihnen die höchste Qualität an ästhetischen Behandlungen zu erschwinglichen Preisen anzubieten. Verschieben Sie Ihre Träume nicht, seien Sie glücklich und schön!",
      features: {
        experience: "Tausende erfolgreicher Operationen mit über 15 Jahren Erfahrung",
        technology: "Moderne Techniken und neueste technologische Ausrüstung",
        approach: "Personalisierte Behandlungspläne und Ansätze"
      },
      button: "Termin Vereinbaren"
    },
  },
  // WhatsApp messages
  whatsapp: {
    appointmentMessage: "Hallo, ich möchte einen Termin vereinbaren."
  },
  about: {
    aestheticsInTurkey: {
      title: "Ästhetik in der Türkei",
      content: {
        intro: "Ästhetische Chirurgie in der Türkei und Häufig Gestellte Fragen zum Reisen in die Türkei",
        advantages: {
          title: "Wird ästhetische Chirurgie in der Türkei durchgeführt?",
          items: [
            "Die Türkei ist in den letzten Jahren zu einem der am meisten bevorzugten Länder für ästhetische Operationen (Liposuktion, Bauchdeckenstraffung, Brustvergrößerung/-straffung etc.) von Tausenden ausländischen Touristen geworden.",
            "Der Grund, warum Tausende ausländischer Touristen die Türkei für ästhetische Chirurgie bevorzugen, ist, dass die Türkei neben ihren kulturellen Werten in Geschichte und Kunst auch Krankenhäuser mit JCI-Akkreditierung (Joint Commission International) und hochqualifizierte Chirurgen mit fortschrittlicher Technologie im Gesundheitsbereich beherbergt.",
            "Wenn Sie die ästhetische Operation, die Sie benötigen, um Ihren Wunschkörper zu erreichen, in Istanbul durchführen lassen möchten, sollten Sie Dr. Barış Çin und sein Team kennenlernen, der in seiner Klinik in Istanbul praktiziert und ein Chirurg mit European Board-Zertifizierung ist.",
            "Mit 10 Jahren Erfahrung werden die ästhetischen Operationen, die Sie benötigen, seit Jahren erfolgreich von Dr. Barış Çin und seinem Team durchgeführt."
          ]
        },
        statistics: {
          title: "Wie viele ausländische Touristen entscheiden sich jährlich für ästhetische Chirurgie in der Türkei?",
          description: "Allein im ersten Halbjahr 2022 kamen 600.000 ausländische Touristen in die Türkei, die im Gesundheitsbereich sehr erfolgreich und beliebt ist, um ästhetische und andere Operationen durchführen zu lassen."
        },
        procedures: {
          title: "Was sind die 10 beliebtesten ästhetischen Operationen in der Türkei?",
          items: [
            "Rhinoplastik",
            "Brustverkleinerung",
            "Liposuktion",
            "Brustvergrößerung",
            "Lidkorrektur",
            "Bauchdeckenstraffung",
            "Ohrkorrektur",
            "Buccal Fat Entfernung",
            "BBL",
            "Augenwinkelkorrektur"
          ],
          additional: "Die in der Türkei durchgeführten ästhetischen Operationen sind jedoch nicht darauf beschränkt. Darüber hinaus werden auch Gesichtsstraffung, Armlifting, Oberschenkelstraffung, Rückenstraffung, vaginale Ästhetik, Augenbrauenlifting, Schläfenlifting und Fuchsauge-Operationen erfolgreich durchgeführt."
        },
        istanbul: {
          title: "Warum sollten Sie sich in Istanbul einer ästhetischen Operation unterziehen?",
          description: "Es gibt mehrere Gründe, Istanbul für ästhetische Chirurgie zu bevorzugen.",
          history: "Istanbul ist die am weitesten entwickelte und größte Stadt der Türkei. Istanbul ist die einzige Stadt der Welt, die sowohl auf dem asiatischen als auch auf dem europäischen Kontinent liegt. Die Geschichte Istanbuls reicht bis 8500 v. Chr. zurück und gewann während der römischen Kaiserzeit (330-396 n. Chr.) große Bedeutung. Die massive Agios-Sofia-Kirche, die 576 n. Chr. erbaut wurde, steht heute noch in ihrer ganzen Pracht.",
          advantages: "Während Sie die historisch und kulturell reiche Stadt Istanbul besuchen, können Sie auch Zugang zu ästhetischen Operationen zu vernünftigen Preisen in Krankenhäusern mit JCI-Akkreditierung (Joint Commission International) mit fortschrittlicher Technologie erhalten, die von hochqualifizierten Chirurgen durchgeführt werden."
        }
      }
    },
    paymentMethods: {
      title: "Zahlungsmethoden",
      content: {
        intro: "Die Zahlungsarten für in unserer Klinik durchgeführte Eingriffe sind wie folgt. Wie in allen Gesundheitseinrichtungen werden die Gebühren für Operationen und medizinische Eingriffe vor Beginn des Eingriffs erhoben. (außer in einigen Notfällen)",
        deposit: {
          title: "Anzahlung und Stornierungsbedingungen",
          description: "Wenn die Operationen unserer Patienten, die sich einer Operation unterziehen werden, in einem Privatkrankenhaus durchgeführt werden sollen, ist eine Anzahlung von etwa 300 Euro erforderlich, um einen Termin im Krankenhaus zu vereinbaren. Diese Anzahlung wird zurückerstattet, wenn sie bis zu 1 Woche vor der Operation storniert wird. Wenn die Operation jedoch in letzter Minute aus willkürlichen Gründen storniert wird, erheben die Krankenhäuser eine Strafgebühr, da sie keine neuen Termine erstellen können. Die Anzahlung wird nach Abzug dieser Gebühr zurückerstattet. Wenn der Eingriff aus Gründen wie Covid+, Infektion oder ungünstigen Anästhesietestergebnissen storniert wird, fällt keine Strafgebühr an. Die Gebühren für Blutuntersuchungen und andere im Krankenhaus durchgeführte Eingriffe werden jedoch vor der Rückerstattung abgezogen. Wenn die Operation oder der Eingriff in der Praxis durchgeführt werden soll, ist keine Anzahlung erforderlich. Bei Flughafentransfer kann jedoch eine Anzahlung für die Zahlung erhoben werden."
        },
        methods: {
          title: "Zahlungsmethoden",
          items: [
            {
              title: "Bargeld",
              description: "In unserer Klinik akzeptieren wir Zahlungen in Türkischer Lira, Dollar und Euro. Der Vorteil dieser Methode ist, dass keine Provision und Währungsumrechnungsgebühren anfallen."
            },
            {
              title: "Physisches POS",
              description: "In unserer Klinik haben wir ein physisches POS-Gerät von İş Bankası. Kostenlose Ratenzahlung ist jedoch nicht möglich. Patienten können jedoch nach Abhebung von ihrer Kreditkarte oder Bankkarte Ratenzahlungen mit Zinsen über ihre eigenen Banken vornehmen. Bei Transaktionen über POS erheben die Banken durchschnittlich 2% vom Karteninhaber und 2% vom Händler. Zusätzlich berechnen sie 6% unter DCC (Direct Currency Exchange) für die Währungsumrechnung. Daher erhöht sich die Transaktionsgebühr um etwa 8-10%."
            },
            {
              title: "Virtuelles POS",
              description: "Für unsere Patienten, die unsere Klinik nicht erreichen können, insbesondere diejenigen, die aus dem Ausland kommen, können wir einen Zahlungslink über das virtuelle POS-System von İş Bankası senden, damit sie ihre Anzahlungen leisten können."
            },
            {
              title: "Western Union",
              description: "Zahlungen können über Western Union an unsere Klinik im Namen von \"Barış Çin\" bei der İş Bankası Ataşehir Filiale, Istanbul, Türkei, gesendet werden. Die Banken erheben je nach zu sendendem Betrag eine Transaktionsgebühr zwischen 4,4-20%."
            }
          ]
        },
        bankTransfer: {
          title: "Banküberweisung – EFT",
          description: "Direkte Überweisungen und EFT können zur Zahlung auf das unten angegebene Konto vorgenommen werden. Die Banken erheben Überweisungsgebühren, Währungsumrechnungsgebühren falls zutreffend, und Provision.",
          accounts: {
            try: {
              title: "Türkische Lira",
              bank: "İş Bankası Ataşehir Filiale (1226)",
              iban: "TR23 0006 4000 0011 2260 5541 37"
            },
            eur: {
              title: "Euro-Konto",
              bank: "İş Bankası Ataşehir Filiale",
              iban: "TR22 0006 4000 0021 2260 4930 40"
            },
            usd: {
              title: "Dollar-Konto",
              bank: "İş Bankası Ataşehir Filiale",
              iban: "TR67 0006 4000 0021 2260 5016 39"
            }
          }
        },
        swift: {
          title: "SWIFT",
          description: "Für unsere Patienten, die Geld aus dem Ausland auf das oben genannte Konto senden möchten, ist der SWIFT-Code der İş Bankası ISBKTRIS. Für Überweisungen aus den USA, CHIPS UID: 003546 (wird anstelle von Routing Code, ABA Number verwendet). Zusätzlich sollte für eine einfachere Erreichbarkeit des Empfängers der Name, Nachname (Barış Çin) und die Adresse des Empfängers (Koşuyolu Mahallesi Mehmet Akfan Sokak No:19-21 Kadıköy İstanbul Turkey) vollständig angegeben werden, und falls bekannt, die 26-stellige IBAN des Empfängers, die mit TR beginnt (International Bank Account Number: TR670006400000212260501639 (Dollar))",
          note: "Besonders bei Banküberweisungen und SWIFT-Transaktionen aus dem Ausland kann es bis zu 2-3 Wochen dauern, bis das Geld die Türkei erreicht, und manchmal werden Überweisungen aus Ländern der Europäischen Union aufgrund von \"Betrugs\"-Verdacht zur Überprüfung zurückgehalten. Zusätzlich kann die Empfängerbank eine Gebühr für die Gutschrift des Geldes auf das Konto erheben. Daher empfehlen wir für internationale Transaktionen die Priorisierung von Bargeld und POS-Geräten, und wenn EFT und SWIFT durchgeführt werden sollen, sollten diese mindestens 1 Monat im Voraus erfolgen. Wenn der vor der Operation oder dem Eingriff angeforderte Gesamtbetrag nicht erhalten wird, wird der Eingriff nicht durchgeführt. Patienten, die EFT- und SWIFT-Zahlungen vornehmen werden, müssen Überweisungen zwischen Konten in derselben Währung vornehmen, da das gesendete Geld sonst nicht das Empfängerkonto erreicht. (Von Türkischer Lira zu Türkisches Lira-Konto, von Dollar-Konto zu Dollar-Konto, von Euro-Konto zu Euro-Konto, usw.)"
        }
      }
    }
  },
  doctorInfo: {
    title: "Ärztliche Informationen",
    name: "Name des Arztes",
    specialty: "Fachgebiet",
    specialtyValue: "Ästhetische, Plastische und Rekonstruktive Chirurgie",
    email: "E-Mail",
    phone: "Telefon",
    socialMedia: "Soziale Medien",
    educationExperience: "Ausbildung & Erfahrung",
    education: "Ausbildung",
    educationValue: "Marmara Universität, Istanbul, Türkei",
    experience: "Erfahrung",
    experienceValue: "Über 15 Jahre Erfahrung",
    expertise: "Fachkenntnisse",
    expertiseValue: "Facharzt für Ästhetische, Plastische und Rekonstruktive Chirurgie",
    biography: "Biografie",
    biographyText1: "Op. Dr. Barış Çin ist ein erfahrener Facharzt für Plastische, Rekonstruktive und Ästhetische Chirurgie, der in seiner Privatklinik in Kadıköy und in führenden Gesundheitseinrichtungen wie den Academic und Acıbadem Krankenhäusern praktiziert.",
    biographyText2: "Als national und international anerkannter Arzt strebt er danach, mit seinem Expertenteam ästhetische Lösungen auf hohem Qualitätsniveau zu erschwinglichen Kosten anzubieten. Mit seinem patientenorientierten Ansatz bietet er seinen Klienten rund um die Uhr Unterstützung.",
    europeanBoard: "European Board Zertifikat: 6. April 2019, Brüssel / Belgien",
    turkishBoard: "Türkisches Board Zertifikat: 28. September 2018, Ankara / Türkei",
    professionalSkills: "Professionelle Fähigkeiten",
    skillsDescription: "Op. Dr. Barış Çin verfügt über Expertise in einem breiten Spektrum der ästhetischen und rekonstruktiven Chirurgie. Nachfolgend sehen Sie einige seiner herausragenden Fähigkeiten:",
    facialAesthetics: "Gesichtsästhetik",
    bodyAesthetics: "Körperästhetik",
    rhinoplasty: "Nasenkorrektur",
    breastAesthetics: "Brustästhetik",
    careerJourney: "Beruflicher Werdegang",
    careerText1: "Nach Abschluss seiner Grundschulausbildung in Ankara gewann Dr. Barış Çin das Ankara Gazi Anatolian Gymnasium und erhielt ein Jahr Englisch-Vorbereitungsunterricht. Nach dem Umzug mit seiner Familie nach Riad/Saudi-Arabien setzte er seine Ausbildung an der Riyadh American International School fort und schloss seine Gymnasialausbildung erfolgreich ab.",
    careerText2: "Nach seiner Rückkehr in die Türkei schloss er sein letztes Gymnasialjahr am Ankara Atatürk Anatolian Gymnasium ab. Er begann sein Medizinstudium an der Medizinischen Fakultät der Marmara Universität und schloss diese Institution erfolgreich ab, womit er den Titel des Mediziners erlangte.",
    careerText3: "Durch die Medizinische Facharztprüfung wurde er in der Abteilung für Plastische, Rekonstruktive und Ästhetische Chirurgie am Istanbul Haydarpaşa Numune Ausbildungs- und Forschungs-Krankenhaus platziert, wo er seinen Facharztprozess fortsetzte. Während dieser Zeit sammelte er viele wissenschaftliche Studien und Fallerfahrungen.",
    careerText4: "Seine akademischen Erfolge und disziplinierte Herangehensweise während seiner Facharztausbildung legten den Grundstein für seine späteren internationalen Erfahrungen und klinischen Praktiken. Während seiner gesamten Karriere nach dem Abschluss hat er sowohl national als auch international eine angesehene Position erlangt.",
    educationAcademic: "Ausbildung & Akademische Erfahrung",
    educationText1: "Während seiner Facharztausbildung war er klinischer Beobachter in der Kieferchirurgie an der Abteilung für Kieferchirurgie der GB Hamburg Universität in Hamburg/Deutschland und bei kraniofazialen Entwicklungsstörungen an der Abteilung für Kraniofaziale Chirurgie der Oxford Universität in Oxford/England. Seine Dissertation wurde als Artikel in Aesthetic Plastic Surgery, einer der weltweit renommiertesten wissenschaftlichen Publikationen im Bereich der ästhetischen Chirurgie, veröffentlicht (Cin B. 2020 Jun;44(3):1087-1088). Neben seiner Dissertation wurden seine Artikel in vielen nationalen und internationalen akademischen Zeitschriften veröffentlicht.",
    educationText2: "Am 28. September 2018 erwarb er das Qualifikationszertifikat durch erfolgreiche Teilnahme an schriftlichen und mündlichen Prüfungen, die von der Türkischen Gesellschaft für Plastische, Rekonstruktive und Ästhetische Chirurgie organisiert wurden. Am 6. April 2019 absolvierte er erfolgreich die Europäischen Qualifikationsprüfungen in Brüssel und wurde vom European Board of Plastic, Reconstructive and Aesthetic Surgery akkreditiert. Zwischen 2021-2022 war er als Assistenzprofessor an der Abteilung für Plastische Chirurgie der Medizinischen Fakultät der Okan Universität tätig. Seit 2021 nimmt er Patienten in seiner Privatpraxis in Istanbul als niedergelassener Arzt auf.",
    appointmentInfo: "Termin und Informationen",
    appointmentDescription: "Kontaktieren Sie uns umgehend, um einen Termin zu Ihrer Wunschzeit zu vereinbaren und detaillierte Informationen zu erhalten."
  },
  skinFiller: {
    title: 'Hautfüller',
    description: 'Hautfüller ist eine effektive ästhetische Anwendung zur Verjüngung der Gesichtskonturen und Wiederherstellung von Volumenverlust.',
    hero: {
      title: 'Natürliches und jugendliches Aussehen mit Hautfüller',
      description: 'Verjüngen Sie Ihre Gesichtskonturen und stellen Sie Volumenverlust mit Hautfüller wieder her, der von unseren Expertenärzten angewendet wird.',
      appointmentButton: 'Termin vereinbaren',
      learnMoreButton: 'Mehr erfahren'
    },
    content: {
      whatIs: {
        description: 'Hautfüller ist eine effektive ästhetische Anwendung zur Verjüngung der Gesichtskonturen und Wiederherstellung von Volumenverlust. Dieses Verfahren macht Gesichtskonturen voller und jünger aussehend durch Injektion von Füllmaterialien unter die Haut.',
        materials: 'Die am häufigsten verwendeten Füllmaterialien sind Hyaluronsäure und Calciumhydroxylapatit. Diese Materialien können vom Körper natürlich aufgenommen und sicher verwendet werden.'
      },
      why: {
        title: 'Warum Hautfüller?',
        reasons: [
          'Verjüngt Gesichtskonturen',
          'Stellt Volumenverlust wieder her',
          'Reduziert Falten',
          'Bietet natürliches Aussehen',
          'Schnelle und effektive Ergebnisse',
          'Minimale Erholungszeit'
        ]
      },
      how: {
        title: 'Wie wird es angewendet?',
        description: 'Die Hautfüller-Anwendung wird von unseren Expertenärzten in einer klinischen Umgebung durchgeführt. Vor dem Eingriff wird eine detaillierte Beratung durchgeführt und ein personalisierter Behandlungsplan erstellt.',
        process: 'Während der Anwendung wird das ausgewählte Füllmaterial mit feinen Nadeln unter die Haut injiziert. Der Eingriff dauert in der Regel 30-45 Minuten und wird unter örtlicher Betäubung durchgeführt.'
      },
      who: {
        title: 'Für wen ist es geeignet?',
        description: 'Hautfüller ist für Menschen geeignet, die Volumenverlust in den Gesichtskonturen erleben, Falten haben und ein jugendlicheres Aussehen wünschen.',
        volumeLoss: 'Es ist eine ideale Lösung besonders für Menschen, die Volumenverlust in Wangen, Schläfen und Kieferlinie erleben.'
      },
      benefits: {
        title: 'Vorteile',
        natural: 'Hautfüller bietet natürlich aussehende Ergebnisse. Nach der Anwendung erscheinen Ihre Gesichtskonturen voller und jünger, aber diese Veränderung erfolgt auf natürliche und ausgewogene Weise.'
      }
    },
    quickInfo: {
      title: 'Schnellinfo',
      duration: 'Behandlungsdauer',
      anesthesia: 'Anästhesie',
      recovery: 'Erholungszeit'
    },
    faq: {
      title: 'Häufig gestellte Fragen',
      questions: [
        {
          question: 'Wie lange hält Hautfüller?',
          answer: 'Die Hautfüller-Anwendung dauert in der Regel 30-45 Minuten. Die Ergebnisse sind sofort sichtbar und halten 6-12 Monate.'
        },
        {
          question: 'Ist Hautfüller schmerzhaft?',
          answer: 'Während des Eingriffs kann ein minimales Unbehagen empfunden werden, aber es gibt keine Schmerzen, da eine örtliche Betäubung verwendet wird.'
        },
        {
          question: 'Wie lange ist die Erholungszeit?',
          answer: 'Die Erholungszeit nach Hautfüller ist recht kurz. In der Regel können Sie innerhalb von 1-2 Tagen zu normalen Aktivitäten zurückkehren.'
        }
      ]
    },
    pricing: {
      title: 'Preisgestaltung',
      hyaluronic: {
        title: 'Hyaluronsäure-Füller',
        price: '500 - 1.000 EUR',
        note: 'Variiert je nach verwendeter Füllermenge'
      },
      calcium: {
        title: 'Calciumhydroxylapatit-Füller',
        price: '800 - 1.500 EUR',
        note: 'Variiert je nach verwendeter Füllermenge'
      },
      lips: {
        title: 'Lippenfüller',
        price: '400 - 800 EUR',
        note: 'Variiert je nach verwendeter Füllermenge'
      },
      jawline: {
        title: 'Kieferlinien-Füller',
        price: '600 - 1.200 EUR',
        note: 'Variiert je nach verwendeter Füllermenge'
      },
      note: '* Preise können je nach verwendeter Füllermenge und Anwendungsbereich variieren.'
    }
  },
  contact: {
    title: 'Kontakt',
    contactInfo: {
      title: 'Kontaktinformationen',
      address: {
        title: 'Adresse',
        content: 'Kosuyolu Bezirk Mehmet Akfan Straße Nr.19-21 Kadikoy Istanbul Türkei'
      },
      phone: {
        title: 'Telefon',
        content: '+90 555 123 4567'
      },
      email: {
        title: 'E-Mail',
        content: 'drbariscin86@gmail.com'
      }
    },
    workingHours: {
      title: 'Öffnungszeiten',
      days: [
        { name: 'Montag - Freitag', hours: '09:00 - 18:00' },
        { name: 'Samstag', hours: '09:00 - 14:00' },
        { name: 'Sonntag', hours: 'Geschlossen' }
      ]
    }
  },
}; 